export default __webpack_public_path__ + "static/media/youtube-icon.32d95c8d.svg";